<script lang="ts">
import EditorStore, { EditorPlaybackControlOwnership } from "@src/model/Editor.Store";

    import MainStore from "@src/model/Main.Store";
    import { onDestroy, onMount } from "svelte";


    let caretElement: HTMLDivElement;
    let subscribeList: any[] = [];
    onMount(() => {
        subscribeList.push(
            MainStore.getValue().currentVideoTimeStamp.subscribe((n) => {
                let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
                caretElement.style.setProperty('left', `${(n / EditorStore.getSegmentLength()) * 100 + timelineOffset}px`);
            }),
            EditorStore.getValue().currentTimelineSizingFactor.subscribe(() => {
                let currentTimestamp = MainStore.getValue().currentVideoTimeStamp.getValue();
                let currentSeglen = EditorStore.getSegmentLength();
                let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
                let pxLeft = currentTimestamp / currentSeglen * 100 + timelineOffset;
                caretElement.style.setProperty('left', `${pxLeft}px`);
            }),
            EditorStore.getValue().currentTimelineTrackDisplayOffset.subscribe((v) => {
                let currentTimestamp = MainStore.getValue().currentVideoTimeStamp.getValue();
                let currentSeglen = EditorStore.getSegmentLength();
                let pxLeft = currentTimestamp / currentSeglen * 100 + v;
                caretElement.style.setProperty('left', `${pxLeft}px`);
            })
        );

        const mouseDownHandler = function(e) {
            document.addEventListener('mousemove', mouseMoveHandler);
            document.addEventListener('mouseup', mouseUpHandler);
            document.body.style.cursor = 'col-resize';
            EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.TIMELINE;
        };
        const mouseMoveHandler = function(e) {
            let timelineOffset = EditorStore.getValue().currentTimelineTrackDisplayOffset.getValue();
            let maxX = (MainStore.getValue().currentVideoLength.getValue() || 0) / EditorStore.getSegmentLength() * 100 + timelineOffset;
            let resultX = Math.min(maxX, Math.max(e.clientX, timelineOffset));
            caretElement.style.setProperty('left', `${resultX}px`);
            EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.TIMELINE;
            MainStore.resetOverlay();
            MainStore.setVideoTimeStamp(
                (resultX - timelineOffset) / 100 * EditorStore.getSegmentLength(),
            );
        };
        const mouseUpHandler = function() {
            caretElement.style.removeProperty('cursor');
            document.body.style.removeProperty('cursor');

            EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.NONE;
            // Remove the handlers of `mousemove` and `mouseup`
            document.removeEventListener('mousemove', mouseMoveHandler);
            document.removeEventListener('mouseup', mouseUpHandler);
        };
        caretElement.addEventListener('mousedown', mouseDownHandler);
    });
    onDestroy(() => {
        subscribeList.forEach((v) => v());
    });


</script>

<div id="ivdemo-timeline-caret" bind:this={caretElement}>
</div>
<div style="width:160px">

</div>

<style>
    #ivdemo-timeline-caret {
        height: calc(300px - 17px - 16px);
        bottom: 1rem;
        background-color: white;
        z-index: 2100;
        margin-top: calc(-2rem - 2px);
        position: fixed;
        cursor: grab;
        width: 2px;
    }
</style>

